let memoryToken = null;

// ✅ Store token in memory
export const setMemoryToken = (token) => {
  memoryToken = token;
};

// ✅ Get token from memory
export const getMemoryToken = () => memoryToken;

// ✅ Clear token from memory (used when token expires or user logs out)
export const clearMemoryToken = () => {
  memoryToken = null;
};
